<style scoped>
    .view-item{
        display: inline-block;
        cursor: pointer;
    }
</style>
<template>
  <div class="view-item">
    <Tooltip
      v-if="tip"
      placement="top"
    >
      <div @click="showItem">
        <slot />
      </div>
      <div slot="content">
        点击查看
      </div>
    </Tooltip>
    <div
      v-else
      @click="showItem"
    >
      <slot />
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      disabled: {
        type: Boolean,
        default: false
      },
      modelId: {
        type: Number
      },
      type: {
        type: String
      },
      tip: {
        type: Boolean,
        default: true
      },
      show_type: {
        type: String,
        default: 'viewer'
      },
      receipt_type: {
        type: String,
      }
    },
    methods: {
      showItem() {
        if (this.disabled) {
          return 
        }
        console.log('this.modelId', this.modelId)
        if (this.show_type === 'drawer') {
          this.showDrawer();
        } else {
          this.showViewer();
        }
      },
      showDrawer() {
        window.eventHub.$emit('drawer-show', this.modelId, this.type)
      },
      showViewer() {
        window.eventHub.$emit('viewer-show', this.modelId, this.type, this.receipt_type)
      }
    }
  }
</script>
